module.exports = __webpack_public_path__ + "static/media/Montserrat-Black.f2e25259.eot";